import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetInstalledProductByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  is_not_deleted: Types.Scalars['Boolean']['input'];
}>;


export type GetInstalledProductByIdQuery = { __typename?: 'query_root', installed_products_by_pk: Array<{ __typename?: 'installed_products', id: any, product_id: any, property_id: any, installation_date: any, warranty_expiration_date?: any | null, warranty_status: string, product_serial?: string | null, product_notes?: string | null, photo_link?: string | null, partner_disconnected_at?: any | null, partner_association?: string | null, location?: string | null, building_id?: any | null, floor_id?: any | null, room_id?: any | null, in_room_location?: any | null, partition_id?: string | null, building?: { __typename?: 'buildings', id: any, name: string } | null, floor?: { __typename?: 'floors', id: any, name: string } | null, room?: { __typename?: 'rooms', id: any, name: string } | null, installed_product_attachments: Array<{ __typename?: 'installed_product_attachments', installed_product_id: any, id: any, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, name?: string | null, transcribed: boolean, type?: string | null, description?: string | null }>, product: { __typename?: 'products', id: any, name: string, description: string, sku?: string | null, make: string, model: string, retail_price?: any | null, product_notes?: string | null, photo_link?: string | null, partition_id?: string | null, product_category: { __typename?: 'product_categories', name: string, label: string }, product_attachments: Array<{ __typename?: 'product_attachments', id: any, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, name?: string | null, transcribed: boolean, type?: string | null, description?: string | null }>, product_guides: Array<{ __typename?: 'product_guides', guide?: { __typename?: 'guides', id: any, title?: string | null } | null }> }, property?: { __typename?: 'properties', id: any, name: string, partition_id?: string | null } | null, device_logs: Array<{ __typename?: 'device_logs', event_state?: string | null, event_timestamp: any, id: any }> }> };


export const GetInstalledProductByIdDocument = gql`
    query getInstalledProductById($id: uuid!, $is_not_deleted: Boolean!) {
  installed_products_by_pk: installed_products(
    where: {id: {_eq: $id}, deleted_at: {_is_null: $is_not_deleted}, _or: [{handover: {status: {_eq: "PUBLISHED"}}}, {handover_id: {_is_null: true}}]}
  ) {
    id
    product_id
    property_id
    installation_date
    warranty_expiration_date
    warranty_status
    product_serial
    product_notes
    photo_link
    partner_disconnected_at
    partner_association
    location
    building_id
    floor_id
    room_id
    in_room_location
    building {
      id
      name
    }
    floor {
      id
      name
    }
    room {
      id
      name
    }
    partition_id
    installed_product_attachments {
      installed_product_id
      id
      photo_link
      document_link
      video_link
      audio_link
      site_link
      transcription
      name
      transcribed
      type
      description
    }
    product {
      id
      name
      description
      sku
      product_category {
        name
        label
      }
      make
      model
      retail_price
      product_notes
      photo_link
      partition_id
      product_attachments {
        id
        photo_link
        document_link
        video_link
        audio_link
        site_link
        transcription
        name
        transcribed
        type
        description
      }
      product_guides(where: {guide: {status: {_eq: "published"}}}) {
        guide {
          id
          title
        }
      }
    }
    property {
      id
      name
      partition_id
    }
    device_logs(limit: 1, order_by: {event_timestamp: desc}) {
      event_state
      event_timestamp
      id
    }
  }
}
    `;

/**
 * __useGetInstalledProductByIdQuery__
 *
 * To run a query within a React component, call `useGetInstalledProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstalledProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstalledProductByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      is_not_deleted: // value for 'is_not_deleted'
 *   },
 * });
 */
export function useGetInstalledProductByIdQuery(baseOptions: Apollo.QueryHookOptions<GetInstalledProductByIdQuery, GetInstalledProductByIdQueryVariables> & ({ variables: GetInstalledProductByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstalledProductByIdQuery, GetInstalledProductByIdQueryVariables>(GetInstalledProductByIdDocument, options);
      }
export function useGetInstalledProductByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstalledProductByIdQuery, GetInstalledProductByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstalledProductByIdQuery, GetInstalledProductByIdQueryVariables>(GetInstalledProductByIdDocument, options);
        }
export function useGetInstalledProductByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInstalledProductByIdQuery, GetInstalledProductByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInstalledProductByIdQuery, GetInstalledProductByIdQueryVariables>(GetInstalledProductByIdDocument, options);
        }
export type GetInstalledProductByIdQueryHookResult = ReturnType<typeof useGetInstalledProductByIdQuery>;
export type GetInstalledProductByIdLazyQueryHookResult = ReturnType<typeof useGetInstalledProductByIdLazyQuery>;
export type GetInstalledProductByIdSuspenseQueryHookResult = ReturnType<typeof useGetInstalledProductByIdSuspenseQuery>;
export type GetInstalledProductByIdQueryResult = Apollo.QueryResult<GetInstalledProductByIdQuery, GetInstalledProductByIdQueryVariables>;